<template>
  <div>
    <Pane />
    <a-modal
      :visible="visible"
      title="资产盘点"
      @cancel="visible = false"
      :footer="null"
      width="800px"
    >
      <div class="content">
        <a-form-model :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-model-item label="资产编码">
                {{ row.assetCode }}
              </a-form-model-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-model-item label="财务编码">
                {{ row.financialCode }}
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-model-item label="资产类型">
                {{ row.categoryName }}
              </a-form-model-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-model-item label="品牌型号">
                {{ row.assetSnapshot ? JSON.parse(row.assetSnapshot).brandModel : '' }}
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-model-item label="资产负责人">
                {{ row.responsiblePersonName }}
              </a-form-model-item>
            </a-col>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-model-item label="资产位置(部门)">
                {{ row.deptName }}
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="12" :md="12" :sm="24">
              <a-form-model-item label="资产执行人">
                {{ row.inventoryOperatorName }}
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="24" :md="24" :sm="24">
              <a-form-model-item
                label="盘点结果"
                :label-col="{ span: 4 }"
                :wrapper-col="{ span: 18 }"
              >
                <a-radio-group v-model="row.inventoryStatus">
                  <a-radio :value="'asset_inventory_status_asset_match'">账实相符</a-radio>
                  <a-radio :value="'asset_inventory_status_asset_exception'">资产异常</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :lg="24" :md="24" :sm="24">
              <a-form-model-item
                label="盘点备注"
                :label-col="{ span: 4 }"
                :wrapper-col="{ span: 18 }"
              >
                <a-textarea v-model="row.inventoryRemarks" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
        <div class="right">
          <a-space>
            <a-button @click="visible = false">取消</a-button>
            <a-button type="primary" @click="saveRow"
              >保存</a-button
            >
          </a-space>
        </div>
      </div>
    </a-modal>
    <a-card class="container">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-row>
          <a-col :span="22">
            <a-form-model-item>
              <a-input v-model="form.assetCode" placeholder="资产编码" />
            </a-form-model-item>
            <a-form-model-item>
              <a-input v-model="form.financialCode" placeholder="财务编码" />
            </a-form-model-item>
            <a-form-model-item>
              <a-input v-model="form.responsiblePersonName" placeholder="资产负责人" />
            </a-form-model-item>
            <a-form-model-item>
              <a-input v-model="form.inventoryOperatorName" placeholder="盘点执行人" />
            </a-form-model-item>
            <a-form-model-item>
              <a-select
                placeholder="资产位置(部门)"
                show-search
                :filter-option="$selectFilterOption"
                v-model="form.deptId"
                style="width: 150px"
              >
                <a-select-option
                  v-for="item in organizationList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.uniqueName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item>
              <a-select
                placeholder="资产类型"
                v-model="form.categoryId"
                style="width: 150px"
              >
                <a-select-option
                  v-for="item in assetsCategoryList"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.subCategoryName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item>
              <a-select
                v-model="form.inventoryStatus"
                placeholder="任务状态"
                style="width: 150px"
              >
                <a-select-option
                  v-for="(item, index) in statusList"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </a-space>
            </a-form-model-item>
          </a-col>

          <a-col :span="2">
            <div class="right" style="margin-top: 4px">
              <a-button
                v-if="$getPermission($route.path + '/add')"
                @click="$router.push($route.path + '/add')"
                type="primary"
                >新建</a-button
              >
            </div>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table
        bordered
        :dataSource="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
      >
        <a-table-column title="资产编码" data-index="assetCode"> </a-table-column>
        <a-table-column title="财务编码" data-index="financialCode"> </a-table-column>
        <a-table-column title="资产类型">
          <template slot-scope="text">
            {{
              assetsCategoryList.find((item) => "" + item.id === text.categoryId)
                .subCategoryName
            }}
          </template>
        </a-table-column>
        <a-table-column title="品牌型号">
          <template slot-scope="text">
            {{ JSON.parse(text.assetSnapshot).brandModel }}
          </template>
        </a-table-column>
        <a-table-column title="资产负责人" data-index="responsiblePersonName">
        </a-table-column>
        <a-table-column title="资产位置(部门)" data-index="deptName"> </a-table-column>
        <a-table-column title="盘点执行人" data-index="inventoryOperatorName">
        </a-table-column>
        <a-table-column title="任务状态">
          <template slot-scope="text">
            <DataDictFinder
              dictType="asset_inventory_status"
              :dictValue="text.inventoryStatus"
              iconType="badge"
            />
          </template>
        </a-table-column>
        <a-table-column title="盘点备注" data-index="inventoryRemarks"> </a-table-column>
        <a-table-column title="盘点执行时间" data-index="inventoryTime"> </a-table-column>

        <a-table-column title="操作" align="right" width="100px">
          <template slot-scope="text">
            <a-space>
              <a href="#" @click.prevent="showDialog(text)">盘点</a>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
      <div class="center" style="margin-top: 100px">
        <a-space>
          <a-button @click="$close($route.path)">关闭</a-button>
        </a-space>
      </div>
    </a-card>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import request from "@/api/request";
import { mapGetters } from "vuex";
import organization from "@/mixins/organization";


function fetchAssetUpdate(data) {
  return request({
    url: "/office-service/fixed/asset/inventory/master/detail/update",
    data,
    method: "post",
  });
} 

function fetchAssetList(data) {
  return request({
    url: "/office-service/fixed-asset-category/list",
    data,
    method: "post",
  });
}
function fetchList(data) {
  return request({
    url: "/office-service/fixed/asset/inventory/master/detail/list",
    data,
    method: "post",
  });
}
function deleteCategory(id) {
  return request({
    url: "/office-service/fixed/asset/inventory/master/delete/" + id,
    method: "post",
  });
}

export default {
  mixins: [watermark, organization],

  data() {
    return {
      form: {},
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      assetsCategoryList: [],
      row: {},
      visible: false,
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("fixed_asset_type");
    },
    statusList() {
      return this.findDataDict("asset_inventory_status");
    },
  },

  mounted() {
    this.id = this.$route.query.id;
    fetchAssetList({
      pageNum: 1,
      pageSize: 10000,
    }).then((res) => {
      if (Array.isArray(res.list)) {
        this.assetsCategoryList = res.list;
      }
    });
    this.getList();
  },

  methods: {
    saveRow() {
      if(this.row.inventoryStatus == 'asset_inventory_status_asset_exception' && !this.row.inventoryRemarks){
        this.$message.error("资产异常必须填写盘点备注")
        return
      }
      fetchAssetUpdate(this.row).then(() => {
        this.$message.success("保存成功");
        this.visible = false;
        this.getList();
      });
    },
    showDialog(text) {
      this.row = JSON.parse(JSON.stringify(text));
      this.row.categoryName = this.assetsCategoryList.find(
        (item) => "" + item.id === text.categoryId
      ).subCategoryName;
      this.visible = true;
    },
    deleteText(text) {
      this.$confirm({
        title: "删除确认",
        content: `确认删除 "${text.inventoryName}" 吗？`,
        onOk: () => {
          deleteCategory(text.id)
            .then(() => {
              this.getList();
            })
            .catch(() => {
              this.$message.error("删除失败");
            });
        },
      });
    },
    getList() {
      const { current, pageSize, form } = this;
      const { dateRange } = this.form;
      let startDateStart;
      let startDateEnd;
      if (Array.isArray(dateRange) && dateRange.length === 2) {
        startDateStart = dateRange[0].format("YYYY-MM-DD");
        startDateEnd = dateRange[1].format("YYYY-MM-DD");
      }
      this.loading = true;
      fetchList({
        pageNum: current,
        pageSize,
        startDateStart,
        startDateEnd,
        masterId: this.id,
        ...form,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = res.totalSize;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    query() {
      this.current = 1;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },
  },
};
</script>
